<div class="sir-item" [style.cursor]="cursor()">
    @if (icon(); as iconName) {
        <sirius-icon class="sir-item-icon" [name]="iconName"></sirius-icon>
    }
    @if (isParent()) {
        <button type="button" class="sir-content-container sir-parent-button" (click)="itemClicked.emit($event)">
            {{ title() }}
            <span class="sir-content">
                @if (subtitle(); as sub) {
                    <span class="sir-subtitle sir-text-style-paragraph-s-default">{{ ' - ' + sub }}</span>
                }
                <sirius-icon class="sir-caret" [name]="'caret_right_small'"></sirius-icon>
            </span>
        </button>
    } @else {
        @let l = link();
        @if (l) {
            <a
                class="sir-content-container"
                [siriusLink]="!l.noRouting ? l : undefined"
                [href]="l.noRouting && l.href ? l.href : null"
                [title]="l.noRouting && l.title ? l.title : null"
                (click)="leafClicked.emit($event)">
                {{ title() }}
                <div class="sir-content">
                    @if (subtitle(); as sub) {
                        <span class="sir-subtitle sir-text-style-paragraph-s-default">{{ ' - ' + sub }}</span>
                    }
                    @if (active()) {
                        <sirius-checkmark></sirius-checkmark>
                    }
                </div>
            </a>
        }
    }
</div>
